<script>
import api from '@utils/api'
import mixins from '../apimixins'
import cloneDeep from 'lodash/cloneDeep'
import TablePaginator from '@components/paginator'
import {convertBatteryCharge} from '@utils/converter'

export default {
  name: 'PoorBattery',
  components: { TablePaginator },
  mixins: [mixins],
  data() {
    return {
      modelName: 'PoorBattery',
      headers: [
        { text: 'workshop', value: 'organisation', sortable: true },
        { text: 'plugGuid', value: 'plug', sortable: true },
        { text: 'battaryCharge', value: 'batteryCharge', sortable: true },
        { text: 'time', value: 'time', sortable: true },
      ],
      lessThan: 30,
    }
  },
  mounted() {
    let settingsFromStore = this.getSettingsFromStore()
    if (settingsFromStore) {
      this.lessThan = settingsFromStore
    }
    this.init()
  },
  methods: {
    submit() {
      this.resetPage()
      this.getDataSet()
    },
    init() {
      this.data = []
      this.loading = true
      this.setSettingsInStore()
      this.getPaginator()
      let filters = this.getFilters()
      if (this.filtersEmpty(filters) || this.$route.params.fromNotification) {
        this.getDataSet()
      }
    },
    setSettingsInStore() {
      this.$store.commit('settings/SET_SETTINGS', {
        name: this.modelName,
        params: cloneDeep(this.lessThan),
      })
    },
    getSettingsFromStore() {
      return this.$store.state.settings.settings[this.modelName]
    },
    async getDataSet() {
      this.loading = true
      this.otherParams = { battery_charge: this.lessThan }
      this.setSettingsInStore()
      this.prepareFilterParams()
      api.getReportData('poor_battery', this.params).then(response => {
        this.setResponseParams(response)
        this.content = response.content
        this.loading = false
      })
    },
    convertBatteryCharge(value) {
      return convertBatteryCharge(value, this.$store.getters['userSettings/get']('batteryChargeDisplay'))
    },
  },
}
</script>

<template>
  <div>
    <v-container fluid>
      <v-layout row>
        <v-flex md2>
          <v-text-field
            v-model.number="lessThan"
            :label="$t('label__battaryCharge')"
            type="number"
            prepend-icon="chevron_left"
          />
        </v-flex>
        <v-flex md2>
          <v-btn
            color="primary"
            @click="submit()"
          >
            {{ $t('buttons__apply') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="loading"
      :class="$style.sdTable"
      hide-actions
    >
      <template 
        slot="headers" 
        slot-scope="props">
        <tr>
          <th
            v-for="header in headers"
            :key="header.text"
            :class="getSortClass(header)"
            style="text-align: left"
            @click="changeSort(header)"
          >
            <span> {{ $t(`label__${header.text}`) }} </span>
            <v-icon
              v-if="header.sortable"
              small>expand_less</v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            <router-link
              v-if="userAllowedToNavigate && props.item.organisation"
              :to="{ name: 'organization', params: { orgId: props.item.organisation }} "> {{ getValue('organization', props.item.organisation) }}
            </router-link>
            <span v-if="!userAllowedToNavigate && props.item.organisation">{{ getValue('organization', props.item.organisation) }}</span>
            <span v-if="!props.item.organisation">{{ '-' }}</span>
          </td>
          <td>
            <router-link
              v-if="userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.plug, goodsGroup: 2 }} "> {{ props.item.plug }}
            </router-link>
            <span v-else>{{ props.item.plug }}</span>
          </td>
          <td>{{ convertBatteryCharge(props.item.batteryCharge) }}</td>
          <td>{{ dateFormat(props.item.time) }}</td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)" />
  </div>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
</style>
